import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Collapse, Typography, Space } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { Panel } = Collapse;

const VibhagDetails = ({
  vibhagName: propVibhagName,
  documents: propDocuments,
  onBack: propOnBack,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get data from either props or navigation state
  const vibhagName = propVibhagName || location.state?.vibhagName;
  const documents = propDocuments || location.state?.documents || [];

  // If no data available, redirect to vibhag list
  if (!vibhagName) {
    navigate("/vibhag");
    return null;
  }

  return (
    <div style={{ padding: "24px", background: "#f5f5f5", minHeight: "100vh" }}>
      {/* Header Section - Only Department Name */}
      <div
        style={{
          marginBottom: "32px",
          background: "#fff",
          padding: "32px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={2} style={{ margin: "0", color: "#1890ff" }}>
          {vibhagName}
        </Title>
      </div>

      {/* Documents Section - Direct PDF Loading */}
      <Space direction="vertical" style={{ width: "100%" }}>
        <Collapse>
          {documents.map((doc, index) => (
            <Panel
              header={
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <FilePdfOutlined
                    style={{ color: "#ff4d4f", fontSize: "18px" }}
                  />
                  <span>{doc.tittle || doc.name}</span>
                </div>
              }
              key={index.toString()}
            >
              {/* Direct PDF Embed */}
              <div
                style={{
                  width: "100%",
                  height: "600px",
                  border: "1px solid #d9d9d9",
                }}
              >
                <iframe
                  src={doc.path || doc.url}
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                  title={doc.tittle || doc.name}
                />
              </div>
            </Panel>
          ))}
        </Collapse>
      </Space>

      {/* Empty State */}
      {documents.length === 0 && (
        <div
          style={{
            background: "#fff",
            borderRadius: "12px",
            padding: "60px 20px",
            textAlign: "center",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <FilePdfOutlined
            style={{
              fontSize: "64px",
              marginBottom: "20px",
              color: "#d9d9d9",
            }}
          />
          <Title level={4} style={{ color: "#999", margin: "0 0 8px 0" }}>
            No Documents Available
          </Title>
        </div>
      )}
    </div>
  );
};

export default VibhagDetails;
